import { Fragment } from 'react';
import type { ReactElement } from 'react';

import { EMPTY_STRING } from '@e-socna/empty';
import { ensureDefined } from '@e-socna/utils';
import { RESOLVER_CONTENT_CLASSNAME } from '@e-socna/printer-contract';

import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

import { useMissionQuickAccess } from './hooks/useMissionQuickAccess.hook';
import { useQuotationContact } from './hooks/useQuotationContact.hook';

export const useDevisInterlocuteur = (
  parameters: ResolverParameters,
): ResolverResult<ReactElement> => {
  const recipient = useQuotationContact(parameters);

  const quickAccess = useMissionQuickAccess(parameters);

  if (!recipient.isSuccess || !quickAccess.isSuccess) {
    return {
      data: undefined,
      error: recipient.error ?? quickAccess.error,
      isSuccess: false,
      isLoading: recipient.isLoading || quickAccess.isLoading,
    };
  }

  const {
    quickAccessData: {
      consolidation: {
        quotationReceiverActor: { thirdParty },
      },
    },
    recipientData: { civility, fullName },
  } = ensureDefined({
    quickAccessData: quickAccess.data,
    recipientData: recipient.data,
  });

  const content = (
    <div className={RESOLVER_CONTENT_CLASSNAME}>
      <p>
        {fullName ? (
          <>
            {civility.label} {fullName}
            <br />
          </>
        ) : (
          EMPTY_STRING
        )}
        {thirdParty.__typename === 'Organization' ? (
          <>
            {thirdParty.name}
            <br />
          </>
        ) : (
          EMPTY_STRING
        )}
        {thirdParty.billingAddress?.letterFormat?.map((line, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={index}>
            {line}
            <br />
          </Fragment>
        ))}
      </p>
    </div>
  );

  return {
    data: { generated: content },
    error: null,
    isSuccess: true,
    isLoading: false,
  };
};
